import { CardContent, Grid, Skeleton } from '@mui/material';
import MainCard from '../../common/card/MainCard';

const IncomeStatusCard = () => (
    <MainCard
        title={"Stato punti di monitoraggio"}
        sx={{
            width: "100%",
            border: "1px solid #E6DEB8",
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
        }}
    >
        <CardContent sx={{ "&.MuiCardContent-root": { padding: 0 } }}>
            <Grid container display="flex" alignItems="center">
                <Grid
                    item
                    container
                    xs={4}
                    sm={12}
                    md={12}
                    lg={12}
                    display="flex"
                    alignItems={"center"}
                >

                    <Grid item ml={1} display="flex" alignItems={"center"}>
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton variant="text" sx={{ marginLeft: 2, width: 45, height: 20 }} />
                    </Grid>
                </Grid>

                <Grid
                    item
                    container
                    xs={4}
                    sm={12}
                    md={12}
                    lg={12}
                    display="flex"
                    alignItems={"center"}
                >

                    <Grid item ml={1} display="flex" alignItems={"center"}>
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton variant="text" sx={{ marginLeft: 2, width: 45, height: 20 }} />
                    </Grid>
                </Grid>

                <Grid
                    item
                    container
                    xs={4}
                    sm={12}
                    md={12}
                    lg={12}
                    display="flex"
                    alignItems={"center"}
                >

                    <Grid item ml={1} display="flex" alignItems={"center"}>
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton variant="text" sx={{ marginLeft: 2, width: 45, height: 20 }} />
                    </Grid>
                </Grid>


            </Grid>
        </CardContent>
    </MainCard >
);

export default IncomeStatusCard;
